import "../../css/fonts.css";
import "../../css/container.css";
import "../../css/misc.css";
import "../../css/subpages.css";

import { useIsMobile } from "../../hooks/is.mobile";
import { CenteredImageStrip } from "../../components/image.strip";
import { ImportAll, shuffleArray } from "../../utils/utils";
import cartGif from "../../assets/gifs/evergrow/cart.gif";
import puzzlesGif from "../../assets/gifs/evergrow/puzzles.gif";
import exploreGiff from "../../assets/gifs/evergrow/explore.gif";
import iconSteam from "../../assets/icons/steam.png";
import { Clickable } from "../../components/clickable.container";
import { useNavigate } from "react-router-dom";
import backIcon from "../../assets/back.png";

const imported = ImportAll(
  require.context("../../assets/Gamedev", false, /\.(png|jpe?g|svg)$/),
);
const images = shuffleArray(imported);

export const GameDevelopment: React.FC<any> = () => {
  const navigate = useNavigate();
  const isMobile = useIsMobile();
  return (
    <div>
      <div>
        {isMobile ? (
          <Clickable
            backgroundUrl={backIcon}
            onclick={() => {
              navigate("/services");
            }}
            style="back"
          />
        ) : (
          ""
        )}
        <div className={"title-text-font" + " " + "text-align" + " " + "title"}>
          One Frame at a Time
        </div>
      </div>
      <div
        style={{
          paddingLeft: isMobile ? "10vw" : "4.5vw",
          paddingRight: isMobile ? "10vw" : "4.5vw",
          paddingTop: isMobile ? "6vw" : "2vw",
          paddingBottom: isMobile ? "6vw" : "1vw",
          fontSize: isMobile ? "3.5vw" : "2.5vw",
          fontStyle: "italic",
        }}
      >
        <p>
          Welcome to the heart of our game development journey. Here, you’ll get
          an inside look at our current project, a game crafted with passion,
          creativity, and countless hours of dedication.
        </p>
      </div>
      {/* PRESSKIT */}
      <div
        style={{
          display: "flex",
          paddingTop: isMobile ? "4vw" : "4vw",
          paddingBottom: isMobile ? "4vw" : "4vw",
          justifyContent: "center",
        }}
      >
        <Clickable
          onclick={() => {}}
          children={
            <a
              href="/PressKit.rar"
              download
              style={{
                display: "flex",
                justifyContent: "center",
                width: "100%",
                justifySelf: "center",
                fontSize: "6vw",
                textAlign: "center",
                color: "white",
                fontFamily: "Orbitron",
                fontWeight: "bold",
              }}
            >
              DOWNLOAD PRESS-KIT
            </a>
          }
          backgroundUrl=""
          style="icon-link-presskit"
        />
      </div>
      <div
        className={"title-text-font" + " " + "text-align" + " " + "sub-title"}
      >
        Evergrow: Shards Of Tomorrow
      </div>

      <div className="text-container">
        <p className={"simple-text"}>
          Explore the ruined world of Evergrow, where echoes of a lost
          civilization whisper through the remnants of a once-thriving planet.
          Solve puzzles to piece together the truth of what led to its downfall.
          Can you restore what was lost, or will the shards of tomorrow shape
          its fate forever?
        </p>
      </div>
      <div style={{ paddingTop: "2vw" }}>
        <CenteredImageStrip images={images} />
      </div>
      <div className="text-container">
        {" "}
        <p className={"simple-text"}>
          <strong>Discover a Unique World:</strong> Explore a desolate wasteland
          in what begins as a search of a mysterious signal. Uncover relics of
          the past that reveal the story of a lost civilization.
        </p>
        <p className={"simple-text"}>
          <strong>Embark on an Adventure:</strong> What starts as a simple
          mission soon unravels into something far greater. In this story-driven
          adventure, solve puzzles to progress and uncover the truth behind the
          planet’s downfall.
        </p>
        <p className={"simple-text"}>
          <strong>A Living Environment:</strong> As you uncover the past,
          witness the world change before your eyes. Clear the corruption and
          restore Evergrow to its former glory.
        </p>
      </div>
      <div className="gif-container">
        <img src={exploreGiff} className="gif-large" />
      </div>
      <div
        className={"title-text-font" + " " + "text-align" + " " + "sub-title"}
      >
        About the Game
      </div>
      <div className="text-container">
        <div className={"simple-text" + " " + "text-align"}>
          <strong>EVERGROW</strong> is a puzzle-adventure game set in a ruined
          world, where players solve puzzles to uncover its forgotten past.
          Inspired by genre-defining classics, it features a stylized aesthetic
          influenced by the timeless charm of older titles.
        </div>
      </div>
      <div className="text-container">
        <div className={"simple-text" + " " + "text-align"}>
          The game's main goal is to provide a visually stunning, atmospheric
          experience while evoking the feeling that no matter how much something
          is broken, it is never fully lost. The game's core loop revolves
          around exploration, solving puzzles, and escaping threats, creating a
          cycle of discovery, challenge, and survival.
        </div>
      </div>
      <div className="gif-container">
        <img src={puzzlesGif} className="gif" />
        <img src={cartGif} className="gif" />
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          paddingLeft: isMobile ? "10vw" : "4.5vw",
          paddingRight: isMobile ? "10vw" : "4.5vw",
          paddingTop: isMobile ? "18vw" : "6vw",
          paddingBottom: isMobile ? "2vw" : "1vw",
          gap: "2vw",
          justifyContent: "center",
        }}
      >
        <Clickable
          onclick={() => {
            window.open(
              "https://store.steampowered.com/app/3623600/Evergrow_Shards_of_Tomorrow/",
              "_blank",
            );
          }}
          children=""
          backgroundUrl={iconSteam}
          style="icon-link"
        />
        <div
          className={"simple-text" + " " + "text-align"}
          style={{ alignSelf: "center" }}
        >
          Don’t forget to wishlist the game on Steam to stay updated and be
          among the first to dive in when we launch!
        </div>
        <Clickable
          onclick={() => {
            window.open(
              "https://store.steampowered.com/app/3623600/Evergrow_Shards_of_Tomorrow/",
              "_blank",
            );
          }}
          children=""
          backgroundUrl={iconSteam}
          style="icon-link"
        />
      </div>
    </div>
  );
};
